Wee.fn.make('search', {
	init: function() {
		var scope = this;

		Wee.events.on({
			'ref:searchInput': {
				'keydown.searchEvents': function(e) {
					var $this = $(this);

					if (e.keyCode === 13) {
						scope.submitSearch($this.val());

						e.stopPropagation();
						e.preventDefault();

						return false;
					}
				},
				'keyup.searchEvents': function(e) {
					var $this = $(this);

					if ($this.val().length) {
						$('ref:searchClear').show();
						$('ref:searchSubmit').show();
					} else {
						$('ref:searchClear').hide();
						$('ref:searchSubmit').hide();
					}

					e.stopPropagation();
					e.preventDefault();

					return false;
				}
			},
			'ref:searchCancel': {
				'click.searchEvents': function(e) {
					scope.hideSearch();

					e.stopPropagation();
					e.preventDefault();

					return false;
				}
			},
			'ref:searchClear': {
				'click.searchEvents': function(e) {
					scope.clearSearch();

					e.stopPropagation();
					e.preventDefault();

					return false;
				}
			},
			'.header__triggers-search': {
				'click.searchEvents': function() {
					scope.showSearch();
				}
			},
			'.search-bar__overlay': {
				'wheel': function(e) {
					e.preventDefault();

					return false;
				},
				'mousewheel': function(e) {
					e.preventDefault();

					return false;
				},
				'touchmove': function(e) {
					e.preventDefault();

					return false;
				},
				'keydown': function(e) {
					if ([37, 38, 39, 40].indexOf(e.keyCode) !== false) {
						e.preventDefault();

						return false;
					}
				}
			}
		});
	},
	showSearch: function() {
		var scope = this,
			$search = $('ref:search'),
			$hero = $('ref:hero');

		Wee.events.on({
			'body': {
				'keyup.searchShowing': function(e) {
					if (e.keyCode === 27) {
						scope.hideSearch();
					}
				}
			},
			'.search-bar__overlay': {
				'click.searchShowing': function() {
					scope.hideSearch();
				}
			}
		});

		// Reset hero parallax
		if ($hero.length) {
			$hero.css('transform', 'translateY(0)')
				.css('margin-top', '0');
		}

		$search.removeClass('-is-hidden');

		window.setTimeout(function() {
			$('ref:stickyHeader').addClass('-search-showing');
			$('.header').addClass('-search-showing');

			$search.addClass('-is-showing');
			$('ref:searchInput')[0].focus();
			$('body').scrollTop(0);
		}, 1);
	},
	hideSearch: function() {
		var scope = this,
			$search = $('ref:search');

		Wee.events.off(false, '.searchShowing');

		$search.removeClass('-is-showing');
		$('ref:stickyHeader').removeClass('-search-showing');
		$('.header').removeClass('-search-showing');

		window.setTimeout(function() {
			$('body').removeClass('lock-scroll');
			$search.addClass('-is-hidden');
			scope.clearSearch();
		}, 200);
	},
	submitSearch: function(searchTerm) {
		this.hideSearch();

		Wee.history.go({
			path: $('.search-bar__search').attr('action') + '?q=' + searchTerm
		});
	},
	clearSearch: function() {
		$('ref:searchInput').val('');
		$('ref:searchClear').hide();
		$('ref:searchSubmit').hide();
		$('ref:searchInput')[0].focus();
	}
}, {});